module.exports = __webpack_public_path__ + "assets/img/logo_prasia@2x.db6be19a.png";